// src/components/stories/StoriesRow.js
import React from "react";
import StoryCard from "./StoryCard";
import "./StoriesRow.css";

export default function StoriesRow({ title, stories }) {
  return (
      <section className="stories-row">
        <h2 className="stories-row-title">{title}</h2>

        <div className="stories-row-wrapper">
          <div className="stories-row-fade-left"></div>
          <div className="stories-row-fade-right"></div>

          <div className="stories-row-list">
            {stories.map((story) => (
              <StoryCard key={story.id} story={story} />
            ))}
          </div>
        </div>
      </section>
  );
}
